import {HeaderTitle} from '@/components/atoms';
import {PageHeader} from '@/components/molecules';
import BulkModifiersList from '@/pages/BulkModifiersList';
import {Header} from '@/utils/constants/header';

const BulkModifiersHome = () => {
  return (
    <div className='bulkModifiersContainer flex flex-col'>
      <PageHeader title='Bulk Point Modifiers' />
      <div className='targetCardComponent mb-5'></div>
      <div
        className='relative'
        style={{
          backgroundColor: 'var(--color-background-layer-01)',
          paddingLeft: '16px'
        }}>
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title='Bulk Point Modifiers List'
          className='bulkModifiersDataTableHeading'
        />
        <BulkModifiersList />
      </div>
    </div>
  );
};

export default BulkModifiersHome;
